import axios from '../axios-auth';
import orginal_axios from "axios";

export const customerProductSaleReportBySaleTeamService = {
  getCustomerProductSaleReportBySaleTeam,
  getCustomerProductSaleReportBySaleTeamSummary,
  exportCustomerProductSaleReportBySaleTeamExcel,
}

function getCustomerProductSaleReportBySaleTeam(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.customerIds) {
    params["customerIds"] = searchParams.customerIds.join();
  }
  if (searchParams.productIds) {
    params["productIds"] = searchParams.productIds.join();
  }
  if (searchParams.saleTeamId) {
    params["saleTeamId"] = searchParams.saleTeamId;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }

  return axios.get("/auth/customer-product-sale-report-by-sale-team", { params });
}

function getCustomerProductSaleReportBySaleTeamSummary(searchParams) {
  let params = {};

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.customerIds) {
    params["customerIds"] = searchParams.customerIds.join();
  }
  if (searchParams.productIds) {
    params["productIds"] = searchParams.productIds.join();
  }
  if (searchParams.saleTeamId) {
    params["saleTeamId"] = searchParams.saleTeamId;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }

  return axios.get("/auth/customer-product-sale-report-by-sale-team-summary", { params });
}

function exportCustomerProductSaleReportBySaleTeamExcel(searchParams) {
  let params = {};

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.customerIds) {
    params["customerIds"] = searchParams.customerIds.join();
  }
  if (searchParams.productIds) {
    params["productIds"] = searchParams.productIds.join();
  }
  if (searchParams.saleTeamId) {
    params["saleTeamId"] = searchParams.saleTeamId;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/customer-product-sale-report-by-sale-team-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}
